var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-view w-full h-auto m-0 p-0"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }